module.exports = __webpack_public_path__ + "static/media/logo_circle.0dc6c052.png";